module.exports = __webpack_public_path__ + "img/gs-logo.91eeefac.png";